import React from 'react';
import './homec1.css'

const Homec1 = (props) => {
    return ( <>
    <div className='homecomp11'>
        <img className='homecompicon' src={props.hicon} alt="" />
        <h6 className='homecomptext'>{props.hcompt}</h6>
    </div>
    </> );
}
 
export default Homec1;